"use client";
import { blueGrey, red, teal } from "@mui/material/colors";
import {
  createTheme,
  getContrastRatio,
  responsiveFontSizes,
} from "@mui/material/styles";

const theme = createTheme({
  palette: {
    colorSchemes: {
      dark: true,
      light: true,
    },
    primary: {
      main: teal[500],
      contrastText: getContrastRatio(teal[500], "#fff") >= 3 ? "#fff" : "#000",
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
      dark: "#eceff1",
      grey: {
        light: "#eef2f6",
        main: "#eceff1",
      },
    },
    grey: {
      light: blueGrey["A100"],
      main: blueGrey["A400"],
      dark: blueGrey["A700"],
    },
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "8px",
          "& .MuiTypography-root": {
            fontSize: 14,
          },
          "& .MuiListItemIcon-root": {
            fontSize: 14,
          },
          "&:hover": {
            backgroundColor: teal[50],
            color: teal[700],
            "& .MuiListItemIcon-root": {
              color: teal[700],
            },
          },
          "&.Mui-selected": {
            backgroundColor: teal[50],
            color: teal[700],
            "& .MuiListItemIcon-root": {
              color: teal[700],
            },
            "& .MuiTypography-root": {
              fontWeight: 600,
            },
          },
        },
      },
    },
  },
});

export default responsiveFontSizes(theme);
